<template>
  <div>
    <h1 v-if="setting">Configurando totem...</h1>
    <h1 v-else>{{ error }}</h1>
  </div>
</template>

<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import io from 'socket.io-client'
import api from '@/api.js'

export default {
  name: 'setup',
  data () {
    return {
      setting: true,
      error: ''
    }
  },
  mounted () {
    const equipmentId = this.$route.params.equipmentId
    const secret = this.$route.params.secret
    const disableVirtualKeyboard = this.$route.params.disableVirtualKeyboard == 1
    console.log('disableVirtualKeyboard', disableVirtualKeyboard)
    let credential = null

    if (!equipmentId) {
      this.error = 'Equipamento não informado!'
      this.setting = false
      return
    }

    if (!secret) {
      this.error = 'Código de autorização não informado!'
      this.setting = false
      return
    }

    try {
      credential = JSON.parse(new Buffer(secret, 'base64').toString('ascii'))
      if (!(credential.app.client_id && credential.app.client_secret && credential.user.client_id && credential.user.client_secret)) {
        throw new Error()
      }
    } catch(e) {
      console.log('Formato do código de autorização inválido!', e)
      this.error = 'Formato do código de autorização inválido!'
      this.setting = false
      return
    }

    // cria o socket com o electron
    Vue.prototype.$socket = io(process.env.VUE_APP_SOCKET)

    // obtém as cameras disponíveis e envia (por socket) a lista para o electron
    navigator.mediaDevices.enumerateDevices().then(deviceInfos => {
      let cameras = []
      for (let i = 0; i !== deviceInfos.length; ++i) {
        let deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "videoinput" && deviceInfo.label !== "screen-capture-recorder") {
          cameras.push(deviceInfo);
        }
      }

      Vue.prototype.$socket.emit('setCameras', cameras)
    })

    this.$store.commit('setCredentialApp', credential.app)
    this.$store.commit('setCredentialUser', credential.user)
    this.$store.commit('setDisableVirtualKeyboard', disableVirtualKeyboard)

    api.requestAppAccessToken().then(r => {
      this.$store.commit('setAuthorizationApp', r)
      
      api.appRequest({
        url: `equipment/${equipmentId}/info`
      }).then(r => {
        if (r.equipment.place.unit.enabled) {
          if (r.equipment.enabled) {
            if (r.equipment.place.type.name === 'area_exposicao') {
              if (disableVirtualKeyboard) {
                // eslint-disable-next-line
                let timerInterval
                Swal.fire({
                  title: "Abrir em tela cheia?",
                  html: "Continua automaticamente em <b></b> segundos.",
                  icon: "info",
                  showCloseButton: false,
                  showCancelButton: true,
                  focusConfirm: false,
                  confirmButtonText: `Sim`,
                  cancelButtonText: `Não`,
                  timer: 5000,
                  timerProgressBar: true,
                  showDenyButton: true,
                  denyButtonText: `Sim`,
                  didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b")
                    timerInterval = setInterval(() => {
                      timer.textContent = `${parseInt(Swal.getTimerLeft()/1000)+1}`
                    }, 100)
                  },
                }).then((result) => {
                  if (result.isDenied) {
                    document.documentElement.requestFullscreen()
                  }

                  this.$store.commit('setEquipment', r.equipment)
                  this.$router.push('/')
                })
              } else {
                this.$store.commit('setEquipment', r.equipment)
                this.$router.push('/')
              }
            } else {
              this.error = `Equipamento #${equipmentId} não pertence ao tipo área de exposição!`
              this.setting = false
            }
          } else {
            this.error = `Equipamento #${equipmentId} desabilitado!`
            this.setting = false
          }
        } else {
          this.error = `Unidade do equipamento #${equipmentId} desabilitada!`
          this.setting = false
        }
      }).catch(e => {
        this.error = `Equipamento #${equipmentId} inválido!`
        console.log(this.error, e)
        this.setting = false
      })
    }).catch(e => {
      this.error = `Código de autorização inválido! (#${equipmentId})`
      console.log(this.error, e)
      this.setting = false
    })
  }
}
</script>